import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Footer from "@/components/Footer";
import ContactForm from "@/components/ContactForm";
import { Marquee, About, Services, Destinations, LaplandFeature, Collections, PropertyYachtSearch, WhyUs, Testimonials } from "@/components/Sections";
import { useLang } from "@/LanguageContext";
import { trackPageview } from "@/lib/track";

// Services is intentionally not rendered on the home page (removed per client direction).
void Services;

let _tracked = false;

export default function Home() {
  const { lang } = useLang();

  useEffect(() => {
    if (!_tracked) {
      _tracked = true;
      trackPageview();
    }
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) (window.__lenis ? window.__lenis.scrollTo(el, { offset: -20 }) : el.scrollIntoView());
      }, 600);
    }
  }, []);

  useEffect(() => {
    document.title =
      lang === "en"
        ? "French Touch Concierge — Bespoke Luxury Travel in France"
        : "French Touch Concierge — Voyages de Luxe Sur Mesure en France";
    const desc =
      lang === "en"
        ? "Ultra-luxury France concierge for discerning travelers worldwide. Bespoke private villas, châteaux, yachts, private aviation and VIP experiences across France."
        : "Conciergerie de luxe en France pour voyageurs exigeants du monde entier. Villas privées, châteaux, yachts, aviation privée et expériences VIP sur mesure.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) { meta = document.createElement("meta"); meta.name = "description"; document.head.appendChild(meta); }
    meta.content = desc;
  }, [lang]);

  return (
    <div className="App bg-ivory">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Destinations />
      <LaplandFeature />
      <Collections />
      <PropertyYachtSearch />
      <WhyUs />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
}
